/* global axios */
import ApiClient from './ApiClient';

class NpsSurveysAPI extends ApiClient {
  constructor() {
    super('nps_surveys', { accountScoped: true });
  }

  active() {
    return axios.get(`${this.url}/active`);
  }

  respond(id, payload) {
    return axios.post(`${this.url}/${id}/respond`, payload);
  }

  impression(id) {
    return axios.post(`${this.url}/${id}/impression`);
  }
}

export default new NpsSurveysAPI();
